import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderInvoiceDetailService } from '../order-invoice-detail.service';
import { OrderInvoiceDetail } from '../order-invoice-detail';
import { OrderInvoiceDetailComponent } from '../order-invoice-detail/order-invoice-detail.component';

@Component({
	selector: 'app-order-invoice-detail-list',
	templateUrl: './order-invoice-detail-list.component.html',
	styleUrls: ['./order-invoice-detail-list.component.css'],
	providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
	standalone: false,
	// make column heading sticky
	styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`]
})
export class OrderInvoiceDetailListComponent implements OnInit {
	constructor(
		private orderInvoiceDetailService: OrderInvoiceDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderInvoiceDetailService.statuses
	}



	// data
	orderInvoiceDetails: any;
	orderInvoiceDetail: OrderInvoiceDetail;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'orderInvoiceDetailId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
	];

	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
	}

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderInvoiceDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderInvoiceDetail-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.orderInvoiceDetailService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderInvoiceDetails = res.data.orderInvoiceDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderInvoiceDetails = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderInvoiceDetail: OrderInvoiceDetail) {
		try {
			this.formLoading = true;
			this.orderInvoiceDetailService.update(orderInvoiceDetail)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderInvoiceDetails.map((orderInvoiceDetail, i) => {
							if (orderInvoiceDetail.orderInvoiceDetailId === res.data.orderInvoiceDetail.orderInvoiceDetailId) {
								this.orderInvoiceDetails[i] = res.data.orderInvoiceDetail;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderInvoiceDetail: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderInvoiceDetail));

			this.formLoading = true;
			this.orderInvoiceDetailService.delete(orderInvoiceDetail.orderInvoiceDetailId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderInvoiceDetails.splice(this.orderInvoiceDetails.indexOf(orderInvoiceDetail), 1);
						this.recordTotal = this.orderInvoiceDetails.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderInvoiceDetail ' + orderInvoiceDetail.orderInvoiceDetailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderInvoiceDetail ' + orderInvoiceDetail.orderInvoiceDetailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OrderInvoiceDetail'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderInvoiceDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOrderInvoiceDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderInvoiceDetail: OrderInvoiceDetail) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderInvoiceDetail: orderInvoiceDetail,
			title: 'Edit OrderInvoiceDetail'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderInvoiceDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOrderInvoiceDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOrderInvoiceDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderInvoiceDetailCB(orderInvoiceDetail: OrderInvoiceDetail) {
		console.log('Adding OrderInvoiceDetail: ' + JSON.stringify(orderInvoiceDetail));
		// if we don't have a orderInvoiceDetails array yet...
		if (!this.orderInvoiceDetails) {
			this.orderInvoiceDetails = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderInvoiceDetails.unshift(orderInvoiceDetail);

		// no idea what this is but it is required to update the array
		this.orderInvoiceDetails = [...this.orderInvoiceDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderInvoiceDetail ' + orderInvoiceDetail.orderInvoiceDetailId + ' Added', life: 3000 });
	}

	updateOrderInvoiceDetailCB(orderInvoiceDetail: OrderInvoiceDetail) {
		console.log('Updating OrderInvoiceDetail: ' + JSON.stringify(orderInvoiceDetail));
		let itemIndex = this.orderInvoiceDetails.findIndex((item: any) => item.orderInvoiceDetailId === orderInvoiceDetail.orderInvoiceDetailId);
		this.orderInvoiceDetails[itemIndex] = orderInvoiceDetail;

		// no idea what this is but it is required to update the array
		this.orderInvoiceDetails = [...this.orderInvoiceDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderInvoiceDetail ' + orderInvoiceDetail.orderInvoiceDetailId + ' Updated', life: 3000 });
	}

	deleteOrderInvoiceDetailCB(orderInvoiceDetail: OrderInvoiceDetail) {
		console.log('Removing OrderInvoiceDetail: ' + orderInvoiceDetail);
		this.orderInvoiceDetails.splice(this.orderInvoiceDetails.indexOf(orderInvoiceDetail), 1);
		this.recordTotal = this.orderInvoiceDetails.length;

		// no idea what this is but it is required to update the array
		this.orderInvoiceDetails = [...this.orderInvoiceDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderInvoiceDetail ' + orderInvoiceDetail.orderInvoiceDetailId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderInvoiceDetails ? this.first === (this.orderInvoiceDetails.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderInvoiceDetails ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderInvoiceDetail: any) {
		if (orderInvoiceDetail?.status) {
			const status = this.statuses.find((e: any) => e.value == orderInvoiceDetail.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
